import vuetify from "@/main";
import TrustDepositModal from '@/components/modals/TrustDepositModal.vue';
import TrustAccounting from '@/modules/settings/company/TrustAccounting/TrustAccounting.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('billing.trust', {
    url: "/trust",
    template: "<div ui-view></div>"
  }).state('billing.trust.summary', {
    track: 'Billing:Trust Summary',
    url: "/summary/{trustId}",
    template: require('./views/summary.html'),
    controller: 'BillingTrustSummaryCtrl'
  }).state('billing.trust.summary.deposit', {
    track: 'Billing:Trust Deposit',
    params: {
      trust: null,
      matter: null,
      client: null
    },
    url: "/deposit",
    views: {
      'edit@billing.trust.summary': {
        ...vuetify(TrustDepositModal)
      }
    }
  }).state('billing.trust.summary.request', {
    track: 'Billing:Trust Request',
    params: {
      trust: null
    },
    url: "/request",
    views: {
      'edit@billing.trust.summary': {
        template: require('../../accounting/views/trust.request.html'),
        controller: 'TrustRequestCtrl'
      }
    }
  }).state('billing.trust.summary.deposit.connect', {
    url: "/connect",
    views: {
      'edit': {
        template: require('../../accounting/views/matter.edit.html'),
        controller: 'MatterAccountingEditCtrl'
      }
    },
    params: {
      message: null,
      cancel: null,
      clientId: null,
      matterId: null,
      onCancel: null
    }
  }).state('billing.trust.summary.request.connect', {
    url: "/connect",
    views: {
      'edit': {
        template: require('../../accounting/views/matter.edit.html'),
        controller: 'MatterAccountingEditCtrl'
      }
    },
    params: {
      message: null,
      cancel: null,
      clientId: null,
      matterId: null,
      onCancel: null
    }
  }).state('billing.trust.summary.setup', {
    url: "/summary",
    ...vuetify(TrustAccounting)
  }).state('billing.trust.matter', {
    track: 'Billing:Trust Matter',
    url: "/matter/{clientId}/{matterId}",
    template: require('./views/matter.html'),
    controller: 'BillingTrustMatterCtrl'
  }).state('billing.trust.matter.connect', {
    url: "/connect",
    params: {
      message: null,
      onCancel: null
    },
    views: {
      'edit': {
        template: require('../../accounting/views/matter.edit.html'),
        controller: 'MatterAccountingEditCtrl'
      }
    }
  }).state('billing.trust.client', {
    track: 'Billing:Trust Client',
    url: "/client",
    template: require('./views/matter.html'),
    controller: 'BillingTrustMatterCtrl'
  }).state('billing.trust.matter.deposit', {
    track: 'Billing:Trust Deposit',
    url: "/deposit",
    params: {
      matter: null,
      client: null
    },
    views: {
      'edit': {
        ...vuetify(TrustDepositModal)
      }
    }
  }).state('billing.trust.matter.request', {
    url: "/request",
    views: {
      'edit': {
        template: require('../../accounting/views/trust.request.html'),
        controller: 'TrustRequestCtrl'
      }
    }
  })
  // .state('billing.trust.matter.deposit.create', {
  //     url: "/create",
  //     views: {
  //         'edit': {
  //             template: require('../../matters/views/create.html'),
  //             controller: 'MatterCreateCtrl'
  //         }
  //     }
  // })
  .state('billing.trust.matter.payment', {
    track: 'Billing:Trust Payment',
    url: "/payment",
    params: {
      amount: null,
      max: null,
      invoices: null
    },
    views: {
      'edit': {
        template: require('../../accounting/views/trust.payment.html'),
        controller: 'TrustPaymentCtrl'
      }
    }
  }).state('billing.trust.matter.setup', {
    url: "/setup",
    views: {
      'edit': {
        template: require('../../accounting/views/trust.matter.html'),
        controller: 'TrustMatterCtrl'
      }
    }
  });
}]);